import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { collections } from "@/mocks/movies";

export default function CollectionSection() {
  return (
    <section className="max-w-6xl mx-auto px-4 md:px-6 mt-12 md:mt-16">
      <SectionHeading
        title="热门影视专题"
        subtitle="按主题成组浏览，快速找到感兴趣的一类作品"
        moreTo="/category?type=movie"
        moreLabel="更多专题"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {collections.map((collection) => (
          <Link
            key={collection.id}
            to={collection.link}
            className="group relative h-64 md:h-72 rounded-lg overflow-hidden border border-background-200 cursor-pointer"
          >
            <img
              src={collection.image}
              alt={`${collection.title}专题封面`}
              title={`${collection.title} - 影视专题合集`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/35 to-transparent" />
            <div className="absolute inset-0 p-5 flex flex-col justify-end">
              <span className="text-accent-300 text-xs font-medium">{collection.subtitle}</span>
              <h3 className="mt-1 font-heading font-bold text-lg text-white">{collection.title}</h3>
              <p className="mt-1.5 text-xs text-white/80 leading-relaxed line-clamp-2">
                {collection.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}